import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  snackBar: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: palette.red.light,
    },
  },
}));
